
export default {


  name: "Register",
  data() {
    return {
      dialogDocs: false,
      src: null,
      titulo: '',
      loading: false,
      isFormValid: true,
      register: {
        cui: "",
        nit: "",
        correo: "",
        confirmar_correo: "",
        telefono: "",
        primer_nombre: "",
        primer_apellido: "",
        confirmPassword: "",
        password: "",
        contratos: null,
        user_type: 3
      },

      user_types: [],

      showPass:false,
      showPassC: false,

      password_nueva: {
        a: (v) => !!v || "Campo obligatorio",
        b: (v) => (v && v.length >= 9) || 'La contraseña debe tener minímo 9 caracteres',
        c: (v) => /[0-9]+/.test(v) || 'Debe contener al menos un número',
        d: (v) => /[!-/]+|@+/.test(v) || 'Debe contener al menos un 1 caracter especial',
      },

      confirmarRules: {
        a: (v) => !!v || "Campo obligatorio",
        b: (v) => (v && v.length >= 9) || 'La contraseña debe tener minímo 9 caracteres',
        c: (v) => (v === this.register.password) || 'Las conttraseñas no coinciden'
      },

      rules_campo_obligatorio: [
        (v) => !!v || "Campo obligatorio"
      ],
      
      emailRules: [
        v => !!v || 'Campo obligatorio',
        v => /.+@.+/.test(v) || 'El correo no es válido',
      ],

      emailRulesC: [
        v => !!v || 'Campo obligatorio',
        v => /.+@.+/.test(v) || 'El correo no es válido',
        v => (v === this.register.correo) || 'Los correos no coinciden'
      ],

      show:false,

      loading_user_types: false
    };
  },



  watch: {
    "register.contratos"() {
      if (this.register.contratos != true) {
        this.register.contratos = null;
      }
    }
  },

  async created() {
    await this.listUserTypes();

  },
  methods: {

    async listUserTypes() {
      try {
        this.loading_user_types = true;
        let r = await this.$store.state.services.gestoresService.listUserTypes();
        this.user_types = r.data.data;
        this.loading_user_types = false;
      } catch {
        this.$toastr.error("Ocurrió un error al obtener los tipos de usuario");        
        this.loading_user_types = false;
      }
    },

    documentos(item) {
      this.titulo = item === 1 ? "TÉRMINOS Y CONDICIONES DECLARA-TIC" : "COBROS AUTOMATICOS"
      this.src = item === 1 ? '/docs/Terminos y condiciones Declara-TIC.pdf' : '/docs/COBROS AUTOMATICOS.pdf'
      this.dialogDocs = true;
    },



    clear() {
      this.register = {
        cui: "",
        primer_nombre: "",
        primer_apellido: "",
        confirmPassword: "",
        password: "",
        contratos: null
      }
    },
    async registrar() {
      //console.log(this.v$.register.$touch());
   
      if (this.$refs.formRegistro.validate()) {
        this.register.nit = this.register.nit.replace("-", "");
        this.loading = true;
        console.log("usuario registrado");
        console.log(this.register);
        try {

          if(this.register.user_type === 5 || this.register.user_type === 6) {
            //envia direccion pendiente y municipio 1
            this.register.direccion = "Pendiente";
            this.register.municipio = 1;
          }

          let r = await this.$store.state.services.registerService.postRegistro(this.register)
          console.log(r);
          if (r.data.data === false) {
            this.$toast.error(r.data.message, { timeout: 3000, position: "top-center" })
            this.loading = false;
          } else {
            this.$toast.success("Usuario creado exitosamente, revisa tu correo para seguir con el proceso de suscripción", { timeout: 8000, position: "top-center" })
            this.$router.push("/")
          }
        } catch (error) {
          //console.log(error);
          this.$toast.error("Error al crear el usuario, comunicate con soporte", { timeout: 3000, position: "top-center" })
          this.loading = false;
        }
      }
    },
    inicio() {
      let home = sessionStorage.getItem("home");
      this.$router.push(home);
    }
  }
};